<template>
	<div style="display: inline;">
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/equipment/check/template/item/page"
			getKey="rows" :columns="columns">
			<template #buttonsL>
				<el-button size="mini" @click="yt.showEditDialog('xinzengdianjianmingxi', null, 'w1')" type="primary">
					{{ $t("xinzeng") }}
				</el-button>
			</template>
			<!-- 工单周期字段 -->
			<template #dianjianzhouqi="scope">
				{{ scope | filterWorkOrderCycle }}
			</template>
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text"
							@click="yt.showEditDialog('bianji',scope.row)">
							{{ $t("bianji") }}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/equipment/check/template/item/delete')">
							{{ $t("shanchu") }}
						</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>
		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzengdianjianmingxi'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('dianjianfenzu')" required="required">
						<el-input v-model="yt.editObj.group"></el-input>
					</el-form-item>
					<el-form-item :label="$t('dianjianneirong')" required="required">
						<el-input v-model="yt.editObj.content"></el-input>
					</el-form-item>
					<el-form-item :label="$t('dianjianzhouqi')" required="required">
						<el-input :value="tip" :readonly="true" @focus="showTime()"
							suffix-icon="el-icon-arrow-down" :placeholder="$t('qingxuanze')"></el-input>
					</el-form-item>
					<el-form-item :label="$t('zhuyishixiang')">
						<el-input v-model="yt.editObj.attention"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{
					  $t("quxiao")
					}}</el-button>
					<el-button size="mini" @click="
              yt.req(
                'POST',
                '/web/equipment/check/template/item/create',
                beforeAdd
              )
            " type="primary">
						{{ $t("baocun") }}
					</el-button>

				</span>
			</template>
			<!-- 更新表单 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('dianjianfenzu')" required="required">
						<el-input v-model="yt.editObj.group"></el-input>
					</el-form-item>
					<el-form-item :label="$t('dianjianneirong')" required="required">
						<el-input v-model="yt.editObj.content"></el-input>
					</el-form-item>
					<el-form-item :label="$t('dianjianzhouqi')" required="required">
						<el-input :value="tip" :readonly="true" @focus="showTime()"
							suffix-icon="el-icon-arrow-down" :placeholder="$t('qingxuanze')"></el-input>
					</el-form-item>
					<el-form-item :label="$t('zhuyishixiang')">
						<el-input v-model="yt.editObj.attention"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{
					  $t("quxiao")
					}}</el-button>
					<el-button size="mini" @click="
              yt.req(
                'POST',
                '/web/equipment/check/template/item/update',
                beforeAdd
              )
            " type="primary">
						{{ $t("baocun") }}
					</el-button>

				</span>
			</template>
		</el-dialog>
		<!-- 点检周期 -->
		<el-dialog :show-close="true" :title="$t('shebeidianjian')" :visible.sync="showSpotCheckDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
				<el-form-item :label="$t('tixingfangshi')" required="required">
					<el-select v-model="yt.editObj.remindType" disabled>
						<el-option :label="$t('antian')" value='1'></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('tixingshijian')" required="required">
					<el-time-picker v-model="yt.editObj.time" :placeholder="$t('qingxuanze')" format='HH:mm'
						value-format="HH:mm">
					</el-time-picker>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="saveTime()">{{$t("quxiao")}}</el-button>
				<el-button size="mini" @click="saveTime()" type="primary">
					{{ $t("baocun") }}
				</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: "admin_data_template_equipment_maintenance_item",
		data() {
			return {
				columns: [{
						label: "dianjianfenzu",
						prop: "group",
						width: 130,
					},
					{
						label: "dianjianneirong",
						prop: "content",
						width: 130,
					},
					{
						label: "zhuyishixiang",
						prop: "attention",
					},
					{
						label: "dianjianzhouqi",
						type: "slot",
					},
					{
						label: "caozuo",
						type: "slot",
						width: 150,
						fixed: "right",
					},
				],
				pickerOptions: {
					format: 'HH:mm'
				},
				showSpotCheckDialog: false,
				shift: [],
			};
		},
		watch: {
			'yt.editObj.action'(value) {
				console.log('sssddddd', value)
				this.$set(this.yt.editObj, 'remindType', '1')
			},
			
		},
		computed: {
			tip() {
				let label = ''
				if (this.yt.editObj.time === undefined) {
					return ''
				}
				if (this.yt.editObj.remindType && this.yt.editObj.remindType == 1) {
					label = '按天-' + this.yt.editObj.time
				}
				if (this.yt.editObj.remindType && this.yt.editObj.remindType == 2) {
					label = '按班次-' + this.yt.editObj.time
				}
				return label
			}
		},
		filters: {
			filterWorkOrderCycle(value) {
				let label = ''
				if (value.row.remindType && value.row.remindType == 1) {
					label = '按天-' + value.row.time
				}
				if (value.row.remindType && value.row.remindType == 2) {
					label = '按班次-' + value.row.time
				}
				return label
			}
		},
		created() {
			setTimeout(() => {
				this.yt.conditions = {
					templateId: this.$attrs.inspectionTemplate.id,
					pageNum: 1,
					pageSize: 10,
				};
				this.yt.get(1);
			}, 300);
		},
		methods: {
		
			beforeAdd(params, url) {
				params.templateId = this.$attrs.inspectionTemplate.id;
				return params;
			},
			showTime() {
				this.showSpotCheckDialog = true
			},
			saveTime() {
				this.showSpotCheckDialog = false
			},
		},
	};
</script>

<style lang="scss" scoped>
	W .shift {
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
	}
</style>
